module.exports = __webpack_public_path__ + "static/AGB_DE_V1.00-07ea5187f582138947ff4940d15e02f5.pdf";